import Vue from "vue";

export default {
  updateEvent(model) {
    return Vue.prototype.$axiosMainClient.post(
      'Appointment/updateReferenceAppointmentDetails',
      model
    );
  }
}